import React from "react";

const ShimmerCard = () => {
    return (
        <div className="col-lg-4 col-md-6 col-sm-6 mb-4 d-flex">
            <div className="shimmer-card d-flex flex-column gap-4" style={{ width: "100%" }}>
                <div className="shimmer-image" />
                <div className="d-flex flex-column">
                    <div className="d-flex flex-column justify-content-between">
                        <div className="d-flex">
                            <div className="shimmer-title" />
                        </div>
                        <div>
                            <ul className="list-unstyled">
                                <li className="shimmer-text" />
                                <li className="shimmer-text" />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .shimmer-card {
                    border: 1px solid #d9d9d9;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    padding: 16px;
                    animation: shimmer 1.5s infinite linear;
                    background: #f0f0f0;
                }

                .shimmer-image {
                    width: 100%;
                    height: 200px;
                    background: #e0e0e0;
                    border-radius: 8px;
                    animation: shimmer 1.5s infinite linear;
                }

                .shimmer-title {
                    width: 60%;
                    height: 24px;
                    background: #e0e0e0;
                    border-radius: 4px;
                    margin-bottom: 8px;
                    animation: shimmer 1.5s infinite linear;
                }

                .shimmer-text {
                    width: 80%;
                    height: 16px;
                    background: #e0e0e0;
                    border-radius: 4px;
                    margin-bottom: 10px;
                    animation: shimmer 1.5s infinite linear;
                }

                @keyframes shimmer {
                    0% {
                        background-position: -200px 0;
                    }
                    100% {
                        background-position: 200px 0;
                    }
                }

                .shimmer-card,
                .shimmer-image,
                .shimmer-title,
                .shimmer-text {
                    background: linear-gradient(
                        90deg,
                        #f0f0f0 25%,
                        #e0e0e0 50%,
                        #f0f0f0 75%
                    );
                    background-size: 200% 100%;
                }

                @media (max-width: 768px) {
                    .shimmer-image {
                        height: 120px;
                    }
                }
                @media (max-width: 1200px) {
                    .shimmer-title {
                        max-width: 220px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default ShimmerCard;
